import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['errorsContainer', 'modalAmount', 'submitButton']
  static values = {
    currency: String,
    errorTranslations: Object,
    leftToCollect: Number,
    locale: String,
    minimumAmount: Number,
    profileBalance: Number,
  }

  validateAmount(event) {
    const amount = event.target.value;
    const errors = [];

    if (amount < this.minimumAmountValue) {
      errors.push(this.errorTranslationsValue.lower_than_minimum_subscription_amount);
    }
    if (amount > this.leftToCollectValue) {
      errors.push(this.errorTranslationsValue.higher_than_left_to_collect);
    }
    if (this.hasProfileBalanceValue && amount > this.profileBalanceValue) {
      errors.push(this.errorTranslationsValue.insufficient_balance);
    }

    this.#displayErrors(errors, event.target);
    this.#toggleSubmitButton(errors);
    this.#updateModalAmount(amount);
  }

  #displayErrors(errors, input) {
    if (errors.length > 0) {
      this.errorsContainerTarget.innerHTML = errors.join('<br>');
      input.classList.add('!border-danger');
    } else {
      this.errorsContainerTarget.innerHTML = ''
      input.classList.remove('!border-danger');
    }
  }

  #toggleSubmitButton(errors) {
    this.submitButtonTargets.forEach(button => {
      button.disabled = errors.length > 0;
    });
  }

  #updateModalAmount(amount) {
    const formattedAmount = new Intl.NumberFormat(this.localeValue, {
      style: 'currency',
      currency: this.currencyValue,
    }).format(amount);

    this.modalAmountTarget.textContent = formattedAmount;
  }
}
